import styled from 'styled-components';

const SidebarList = styled.ul`    
    margin: 0px;
    padding: 0px;
    list-style: none;
    white-space: nowrap;
}
`;

export default SidebarList;
